import React, { useEffect, useState } from 'react'
import logoDark from 'assets/images/finops-horizontal-dark.svg'
import logoLight from 'assets/images/finops-horizontal-light.svg'
import { useTheme } from 'hooks'

const Logo = ({ alt, className, style = {}, height = 40 }) => {
  const [imageExists, setImageExists] = useState(false)
  const { theme } = useTheme()

  useEffect(() => {
    const publicImagePath = process.env.PUBLIC_URL + '/customer-logo.svg'

    const img = new Image()
    img.src = publicImagePath

    img.onload = () => {
      setImageExists(true)
    }

    img.onerror = () => {
      setImageExists(false)
    }
  }, [])

  const defaultLogo = theme === 'dark' ? logoDark : logoLight
  const imageUrl = imageExists ? process.env.PUBLIC_URL + '/customer-logo.svg' : defaultLogo

  return <img alt={alt} className={className} src={imageUrl} height={height} style={{ ...style }} />
}

export default Logo
